import { render } from "./ContentPengaduanNasabah.vue?vue&type=template&id=8378e244&scoped=true"
import script from "./ContentPengaduanNasabah.vue?vue&type=script&lang=js"
export * from "./ContentPengaduanNasabah.vue?vue&type=script&lang=js"

import "./ContentPengaduanNasabah.vue?vue&type=style&index=0&id=8378e244&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8378e244"]])

export default __exports__